import {useEffect, useState} from "react";
import {useSnackbar} from "notistack";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ConfirmDialog from "../../ConfirmDialog";
import {useDeleteCarrierMutation} from "../../../services/authService";
import messages from "../../../utils/messages";
import styles from "../showName/DeleteShowName.module.scss";

const DeleteFlightCarrier = ({ flightCarrier, setFlightCarrier, onDelete }) => {
    const [deleteCarrier, { isSuccess, error, reset }] = useDeleteCarrierMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteCarrier(flightCarrier.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteFlightCarrier}`, { variant: 'success' });
            reset();
            onDelete();
            setFlightCarrier(null);
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete flight carrier"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteFlightCarrier}
            </ConfirmDialog>
        </>
    )
}

export default DeleteFlightCarrier;
